import request from "../Config/axios";
// -----------------------------------------------------------
export const GetAll_Paging_FoodListPeriod_Api = async (params) => {
    const { data } = await request.post(
        `/FoodListPeriod/GetAll_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Add_FoodListPeriod_Api = async (params) => {
    const { data } = await request.post(
        `/FoodListPeriod/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetById_FoodListPeriod_Api = async (id) => {
    const { data } = await request.get(
        `/FoodListPeriod/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const Update_FoodListPeriod_Api = async (params) => {
    const { data } = await request.post(
        `/FoodListPeriod/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_FoodListPeriod_Api = async (id) => {
    const { data } = await request.delete(
        `/FoodListPeriod/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
